module.exports = __webpack_public_path__ + "images/canonical-comment/dismiss-icon.d41d56fca6f4556e0a02.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-comment/dismiss-icon.svg
// module id = 7AP/
// module chunks = 2